import { memo } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { NavLink } from 'react-router-dom';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const ChatsWidget = () => {
  return (
    <Card sx={{ width: '100%', maxWidth: 320, p: 2 }}>
      <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', pt: 1, pb: 3 }}>
        <Typography sx={{ fontSize: '1.25rem', fontWeight: 800 }}>Chats</Typography>
        <Button variant='outlined' component={NavLink} to='/patients'>Chat</Button>
      </Box>
    </Card>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <ChatsWidget {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);